export function LogsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.LOGS + '/:param')
        .setCustomActions({
            'getLogs': {
                method: 'GET',
                params: {param: 'feed'}
            },
            'downloadLogs': {
                method: 'GET',
                params: {param: 'download'}
            },
            'getServiceLevel': {
                method: 'GET',
                params: {param: 'level'}
            },
            'setServiceLevel': {
                method: 'POST',
                params: {param: 'level'}
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/logs_dao.js